import React from 'react';
import { Box, useTheme } from '@mui/material';

const ClockLoader = ({ size = 96 }) => {
  const theme = useTheme();
  const stroke = theme.palette.primary.main || '#1976d2';
  const rim = theme.palette.grey[200] || '#eee';

  return (
    <Box sx={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width="100%" height="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="rimGrad" x1="0%" x2="100%">
            <stop offset="0%" stopColor={rim} />
            <stop offset="100%" stopColor={rim} stopOpacity="0.85" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="44" fill="none" stroke="url(#rimGrad)" strokeWidth="6" />
        <circle cx="50" cy="50" r="40" fill="none" stroke={stroke} strokeOpacity="0.06" strokeWidth="8" />

        {/* rotating hand */}
        <g>
          <line x1="50" y1="50" x2="50" y2="22" stroke={stroke} strokeWidth="4" strokeLinecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1s" repeatCount="indefinite" />
          </line>
        </g>

        {/* center dot */}
        <circle cx="50" cy="50" r="3.5" fill={stroke} />
      </svg>
    </Box>
  );
};

export default ClockLoader;
